// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b6a00438","455":"7d029265","977":"7be60ab8"}[chunkId] + ".chunk.js";
};